import React, { useContext, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader } from "../components/loader/loader.component";
import { UserStateContext } from "../components/context/user-state-context";
import CONSTANTS from "../shared/constants";
import Page403Forwarder from "../pages/403-forwarder";
import NoCompanyPage from "../pages/no-company";

export const AuthCheck = ({ children }) => {
  const { user, asCompany, isLoadingFlags } = useContext(UserStateContext);
  const location = useLocation();

  const MYLOCAL = "https://fe.krichey.vm.cinch.io";

  const forwardingTarget =
    CONSTANTS.ENV === "LOCAL"
      ? MYLOCAL
      : CONSTANTS.ENV === "DEV"
      ? "https://marketing-dev.cinch.io"
      : "https://marketing.cinch.io";

  const hostname =
    CONSTANTS.ENV === "LOCAL"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;

  // We haven't loaded the user yet.
  if (user === undefined) return <Loader overlay />;

  // User is not logged in.
  if (!user) {
    // Redirect to marketing site for login

    window.location.replace(
      `${forwardingTarget}/sign-in?redirect=${encodeURIComponent(
        hostname + location.pathname + location.search
      )}&source=employee-operations`
    );
    return null;
  }

  // Loaded, logged in, but not attached to any company. Without this
  // branch the loader below would spin forever (asCompany can't resolve
  // when the user has zero companies). Only reachable now that AuthCheck
  // admits every @cinch.io user — before the widening, the whitelist
  // guaranteed all admitted users had companies.
  if (Array.isArray(user.companies) && user.companies.length === 0) {
    return <NoCompanyPage />;
  }

  // Still waiting for asCompany to resolve for a user that DOES have companies.
  if (!asCompany) return <Loader overlay />;

  //delete authenication param from url after login
  const searchParams = new URLSearchParams(location.search);
  const authenticationParam = searchParams.get("authentication");
  if (authenticationParam) {
    searchParams.delete("authentication");
    const newUrl =
      location.pathname +
      (searchParams.toString() ? "?" + searchParams.toString() : "");
    window.history.replaceState({}, "", newUrl);
  }

  // Any Cinch employee (@cinch.io) can enter the app; individual
  // routes decide what they can see via <RequireAccess access=...>.
  // `cinch_employee` is the identity role in INTERNAL_ROLES on the
  // backend — served to the FE inside `internal_roles` on /users/me.
  if (!user.internal_roles?.includes("cinch_employee")) {
    return <Page403Forwarder forward={forwardingTarget} />;
  }

  // The sidebar integrations and company fields data are still loading.
  if (isLoadingFlags) return <Loader overlay />;

  // Everything looks good, go ahead and render
  return children;
};
